import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from "react-redux";
import PaymentTray from '../components/Wallet/PaymentTray'
import { withRouter } from 'react-router-dom'
import { getUserCodesCharges, cancelPayment } from './../actions/user-codes'
import DialogConfirm from '../components/Complements/DialogConfirm';
import MainSimple from '../components/Menu/MainSimple';
// import { useStylesTable } from './../components/Complements/usesStyles'


class ChargeTrayContainer extends Component {
    state = {
      title: 'Cancelar',
      subTitle: 'Desea cancelar el pago solicitado?',
      openDialog: false,
      amount: 0,
      request: '',
      otp: 0,
      sequence: '',
      message: '',
      type: '',
      openSnackbar: false,
      payments: []
    };
    componentDidMount() {
        (this.props.userCodesCharge.length === 0) ? this.fetchUserCodes(this.props.user.vusk, this.props.PaymentType) :
        this.setState({
            payments: this.props.userCodesCharge
        })
        // this.fetchUserCodes(this.props.user.vusk, this.props.PaymentType)
    }
    
    fetchUserCodes = (cedule, PaymentType) => {
        cedule && this.props.getUserCodesCharges(PaymentType, cedule).then(({payload})=> {
            this.setState({
                payments: payload
            })
        })
    }
    handleOpenDialog = (data) => {
        return (data.checked === 0) && this.setState({ openDialog: true, sequence: data.sequence ,amount: data.amount, request: data.request, otp: data.otp })
    }
    handleCloseDialog = () => {
      this.setState({ openDialog: false });
    };

    handlePayType = (option) => {
        const { sequence } = this.state
        return (option === 'Si') && this.props.cancelPayment(sequence, 4).then(r => {
            r.payload && this.setState({
                payments: this.props.userCodesCharge
            })
            this.props.handleOpenSnack('Pago cancelado', 'success')
        })
    }

    handleOncloseSnack = () => {
        this.setState({ openSnackbar: false });
    }
    /* handleOpenSnack = (message, type) => {
        this.setState({ openSnackbar: true, message, type });
    } */

    createButton = (name) => {
        return { name }
    }
    
    renderBody = () => {    
        return  <div>
                    <PaymentTray
                        {...this.props}
                        classes = { this.props }
                        typeRequest = 'Charge'
                        paymentsData = { this.state.payments }
                        handleOpenDialog= { this.handleOpenDialog }
                        // handleSubmit={ this.handleSubmit }
                    />
                    <DialogConfirm
                        {...this.state} 
                        onCloseDialog = { this.handleCloseDialog }
                        PayType = { this.handlePayType }
                        buttons = { [ this.createButton('Si'),  this.createButton('No') ]}
                    />
                </div>
    }
    render() {
        // const { title } = this.props
        return (
            <div>
                <MainSimple
                    body = { this.renderBody() }
                />

            </div>
        )
    }
}


ChargeTrayContainer.propTypes = {
    user: PropTypes.object.isRequired,
    userCodesCharge: PropTypes.array.isRequired,
    PaymentType: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    handleOpenSnack: PropTypes.func.isRequired, 
}


export default withRouter(connect(null, { getUserCodesCharges, cancelPayment } )(ChargeTrayContainer));
// export default PaymentTrayContainer